import { useState } from "react";
import { Category } from "../types";
import { Action } from "./useHabitState";

export const useCategoryActions = (
  dispatch: React.Dispatch<Action>,
  categories?: Category[],
) => {
  const [addCategoryDialogOpen, setAddCategoryDialogOpen] = useState(false);
  const [editCategoryDialogOpen, setEditCategoryDialogOpen] = useState(false);
  const [currentCategory, setCurrentCategory] = useState<Category | null>(null);

  const handleAddCategory = () => {
    const newCategory: Category = {
      id: Date.now(),
      name: "",
    };
    setCurrentCategory(newCategory);
    setAddCategoryDialogOpen(true);
  };

  const handleEditCategory = (category: Category) => {
    setCurrentCategory(category);
    setEditCategoryDialogOpen(true);
  };

  const handleSaveCategory = () => {
    if (currentCategory?.name) {
      // Check if the category actually exists in the current state
      const existingCategory = categories?.find(
        (cat) => cat.id === currentCategory.id,
      );

      if (existingCategory) {
        // It's an existing category, so edit it
        dispatch({ type: "EDIT_CATEGORY", payload: currentCategory });
      } else {
        // It's a new category, so add it
        dispatch({ type: "ADD_CATEGORY", payload: currentCategory });
      }
      setAddCategoryDialogOpen(false);
      setEditCategoryDialogOpen(false);
    }
  };

  const handleRemoveCategory = (id: number) => {
    dispatch({ type: "REMOVE_CATEGORY", payload: id });
    setEditCategoryDialogOpen(false);
  };

  return {
    addCategoryDialogOpen,
    setAddCategoryDialogOpen,
    editCategoryDialogOpen,
    setEditCategoryDialogOpen,
    currentCategory,
    setCurrentCategory,
    handleAddCategory,
    handleEditCategory,
    handleSaveCategory,
    handleRemoveCategory,
  };
};
